import { styled } from '@mui/material/styles';

export const TableWrapper = styled('div')`
  overflow: auto;
  width: 100%;
  max-height: calc(100vh - 278px);
`;